const state = {
  modalBox: {
    isActiveStatus: false,
    type: 0, // 0: Create, 1: Edit, 2: View (Others)
    alias: "",
    hash: "",
  },
  secondModalBox: {
    isActiveStatus: false,
    type: 0, // 0: Create, 1: Edit
    alias: "",
    hash: "",
  },
  loader: {
    isActiveStatus: false,
  },
  notification: {
    notificationList: [],
    nextId: 0,
  },
  // menu location
  location: "",
  // theme
  theme: localStorage.getItem("theme") || "dark",
};

const getResetModalBox = () => {
  return {
    isActiveStatus: false,
    type: 0, // 0: New, 1: Edit
    alias: "",
    hash: "",
  };
};

const mutations = {
  CHAANGE_LOCATION(state, value) {
    state.location = value;
  },
  RESET_MODALBOX(state) {
    Object.assign(state.modalBox, getResetModalBox());
    document.body.classList.remove("modal-open");
    // Restore scroll position
    if (document.body.dataset.scrollY) {
      document.body.style.top = "";
      window.scrollTo(0, parseInt(document.body.dataset.scrollY));
      delete document.body.dataset.scrollY;
    }
  },
  CLOSE_SECOND_MODALBOX(state) {
    Object.assign(state.secondModalBox, {
      isActiveStatus: false,
      type: 1,
      alias: "",
      hash: "",
    });
  },
  MODALBOX_ACTIVATION(state, value) {
    Object.assign(state.modalBox, value.isActiveStatus);
    // Save current scroll position before fixing body position
    const scrollY = window.scrollY;
    document.body.dataset.scrollY = scrollY;
    document.body.style.top = `-${scrollY}px`;
    document.body.classList.add("modal-open");
  },
  SECOND_MODALBOX_ACTIVATION(state, value) {
    Object.assign(state.secondModalBox, value);
  },
  LOADING(state, value) {
    state.loader = value;
  },
  NOTIFICATION_MESSAGE(state, value) {
    // The same text twice within a moment (an interceptor and a page both
    // reporting one failure) reads as a glitch; keep the first.
    const dup = state.notification.notificationList.find(
      (n) => n.message === value.message && Date.now() - (n.at || 0) < 1500
    );
    if (dup) return;
    const notification = {
      at: Date.now(),
      ...value,
      id: state.notification.nextId++,
      timer: setTimeout(() => {
        const index = state.notification.notificationList.findIndex(
          (n) => n.id === notification.id
        );
        if (index !== -1) {
          state.notification.notificationList.splice(index, 1);
        }
      }, 2000),
    };
    state.notification.notificationList.push(notification);
  },
  REMOVE_NOTIFICATION(state, index) {
    const notification = state.notification.notificationList[index];
    if (notification && notification.timer) {
      clearTimeout(notification.timer);
    }
    state.notification.notificationList.splice(index, 1);
  },
  SET_THEME(state, theme) {
    state.theme = theme;
    localStorage.setItem("theme", theme);
    document.documentElement.setAttribute("data-theme", theme);
  },
  TOGGLE_THEME(state) {
    const next = state.theme === "light" ? "dark" : "light";
    state.theme = next;
    localStorage.setItem("theme", next);
    document.documentElement.setAttribute("data-theme", next);
  },
};

const actions = {
  showModalBox(context, value) {
    if (value.isActiveStatus) {
      context.commit("MODALBOX_ACTIVATION", value);
    } else {
      context.commit("RESET_MODALBOX");
    }
  },
  showSecondModalBox({ commit }, value) {
    if (value.isActiveStatus) {
      commit("SECOND_MODALBOX_ACTIVATION", value);
    } else {
      commit("RESET_MODALBOX");
    }
  },
};

const getters = {
  getModalState: (state) => {
    return state.modalBox.isActiveStatus;
  },
  getFormType: (state) => {
    if (state.secondModalBox.isActiveStatus) {
      return state.secondModalBox.type;
    } else {
      return state.modalBox.type;
    }
  },
  getSecondModalState: (state) => {
    return state.secondModalBox.isActiveStatus;
  },
  getLoadingStatus: (state) => {
    return state.loader.isActiveStatus;
  },
  isContentLoaded: (state) => {
    return !state.loader.isActiveStatus;
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
